import * as React from "react";
const SvgRectangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 8 9", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 4, width: 6, height: 6, rx: 1, transform: "rotate(45 4 0)", fill: "currentColor" }));
export default SvgRectangle;
